const form = (editor) => {

    editor.BlockManager.add('form', {
        label: `
                    <svg  width="1.4vw" height="1.4vw" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path class="gjs-block-svg-path" d="M22,5.5 C22,5.2 21.5,5 20.75,5 L3.25,5 C2.5,5 2,5.2 2,5.5 L2,8.5 C2,8.8 2.5,9 3.25,9 L20.75,9 C21.5,9 22,8.8 22,8.5 L22,5.5 Z M21,8 L3,8 L3,6 L21,6 L21,8 Z" fill-rule="nonzero"></path>
                      <path class="gjs-block-svg-path" d="M22,10.5 C22,10.2 21.5,10 20.75,10 L3.25,10 C2.5,10 2,10.2 2,10.5 L2,13.5 C2,13.8 2.5,14 3.25,14 L20.75,14 C21.5,14 22,13.8 22,13.5 L22,10.5 Z M21,13 L3,13 L3,11 L21,11 L21,13 Z" fill-rule="nonzero"></path>
                      <rect class="gjs-block-svg-path" x="2" y="15" width="10" height="3" rx="0.5"></rect>
                    </svg>
                    <div class='gjs-fontFamily gjs-block-label'>Plain Form</div>
                  `,
        category: 'Forms ',
        content: `<form wablitype="form" wabliname="form" class='p-3'>
                    <div class="form-group flex flex-column">
                    <label class="col-form-label p-2 font-weight-bold">Name</label>
                    <input type="text" placeholder="Name" class="form-control p-2" required />
                    </div>
                    <div class="form-group flex flex-column">
                    <label class="col-form-label p-2 font-weight-bold" >Email</label>
                    <input type="email" placeholder="Email" class="form-control p-2" required />
                    </div>
                    <div class="form-group flex flex-column">
                      <label for="date" class="col-form-label p-2 font-weight-bold" >Date</label>
                      <div class="input-group date" id="datepicker">
                        <input type="text" class="form-control" id="date"/>
                        <span class="input-group-append">
                          <span class="input-group-text bg-light d-block">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                    </div>
                    <div class="form-group flex align-items-center">
                    <label class="form-check-label p-2 font-weight-bold">Gender</label>
                    <div class="form-check form-check-inline margin-left" wablitype='radios'>
                      <input class="form-check-input p-2" type="radio" id="inlineRadio1" checked value="M"/>
                      <label class="form-check-label" for="inlineRadio1">Male</label>
                    </div>
                    <div class="form-check form-check-inline form-group margin-left" wablitype='radios'>
                      <input class="form-check-input" type="radio" id="inlineRadio1" value="F"/>
                      <label class="form-check-label" for="inlineRadio1">Female</label>
                    </div>
                    </div>
                    <div class="form-group flex flex-column">
                    <label class="col-form-label p-2 font-weight-bold">Message</label>
                    <textarea class="form-control p-2"></textarea>
                    </div>
                    <div class="form-group ">
                    <button  class="btn btn-primary pointer">Send</button>
                    </div>
                  </form>
                        `,
        attributes: {}
    });

    
}

export default form;